<template>
  <section class="cube-container">
    <!-- <div id="headline" class="headline">{{ headline }}</div> -->
    <div class="cube" style="transform: scale(1);"></div>
  </section>
</template>
<script>
  import anime from "animejs"
  export default {
    name: "Cube",
    props: ["headline"],
    data() {
      return {
        newText: "",
      }
    },
    mounted() {
      this.$nextTick(function() {
        // Code that will run only after the entire view has been rendered
        this.createCube()
        anime({
          targets: ".cube",
          width: [
            { value: 1, easing: "easeInOutQuad" },
            { value: 2500, easing: "easeInOutQuad" },
            { duration: 500 },
          ],
          height: [
            { value: 1, easing: "easeInOutQuad" },
            { value: 2500, easing: "easeInOutQuad" },
            { duration: 500 },
          ],
          // rotate: [
          //   { value: 0, easing: "easeInQuad" },
          //   { value: 12.5, easing: "easeOutQuad" },
          //   { duration: 300 },
          // ],
          opacity: {
            value: ["0", "100", "0"],
            easing: "easeInOutQuad",
            duration: 700,
          },
          delay: anime.stagger(300),
          loop: true,
          direction: "alternate",
        })
      })
    },
    methods: {
      createCube: async function() {
        for (var i = 0; i < 8; i++) {
          this.newText += "<div class='cube'></div>"
        }
        document.querySelector(".cube-container").innerHTML = this.newText
      },
    },
  }
</script>
<style lang="scss">
  @import "./src/scss/style--light";

  .cube-container {
    display: block;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }

  .cube {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: center;
    width: 1rem;
    height: 1rem;
    box-shadow: 0px 0px 60px 0px rgba(255, 255, 255, 0.75);
    color: transparent;
    border: 2px solid rgba(255, 255, 255, 0.35);
  }

  // .grid {
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: center;
  // }
  // .grid__item {
  //   pointer-events: none;
  //   position: relative;
  //   width: 22px;
  //   height: 22px;
  //   margin: 1px;
  //   background-color: rgba(51, 51, 51, 0.8);
  //   font-size: 14px;
  //   border-radius: 0;
  //   background-image: url("/img/bg-grid.svg");
  // }

  // .grid__item::before {
  //   content: "";
  //   display: block;
  //   width: 2px;
  //   height: 2px;
  //   background-color: rgba(var(--background-secondary), 1);
  //   position: relative;
  //   top: -2px;
  //   left: -2px;
  // }

  // .headline {
  //   position: absolute;
  //   display: flex;
  //   z-index: 10;
  // }
</style>
